import Vue from 'vue'
import Api from '../../services/Api';

const app = {
    namespaced: true,
    state: {
        latitude: undefined,
        longitude: undefined,
        altitude: undefined,
        timestamp: undefined,
        status: 0,
        error: null
    },
    getters: {
    },
    mutations: {
        setError: (state, payload) => {
            state.status = -1
            state.error = payload
        },
        setNotAvailable: (state) => {
            state.status = -2
            state.error = null
        },
        setCoordinates: (state, payload) => {

        }
    },
    actions: {
        init: (context) => {
            return new Promise((resolve, reject) => {
                try{
                    if(navigator && navigator.geolocation){
                        navigator.geolocation.getCurrentPosition((data) => {

                        }, (error) => {
                            console.log(error)
                        })
                    }else{
                        context.commit('setNotAvailable')
                        reject(undefined)
                    }
                }catch(e){
                    context.commit('setError', e)
                    reject(e)
                }
                resolve()
            })
        }
    }
}

export default app;



// WEBPACK FOOTER //
// ./resources/js/store/modules/gps.js